import React, { useState, useEffect } from "react";

import { CButton, CDataTable, CBadge } from "@coreui/react";
import { connect, useSelector } from "react-redux";
import { bindActionCreators } from "redux";

import { logout } from "../../../actions/baseActions";
import { setObj } from "../../../actions/noteActions";
import URL from "../../../config/api";
import axios from "../../../config/axios";

import "./styles.css";

const StudentPresenceTable = props => {
  const [details, setDetails] = useState([]);
  const [fields, setFields] = useState([
    { key: "nome", _style: { width: "40%" } },
    { key: "status", _style: { width: "20%" } },
    {
      key: "show_details",
      label: "",
      _style: { width: "11%" },
      sorter: false,
      filter: false
    }
  ]);
  const [usersData, setUsersData] = useState(null);
  const token = useSelector(state => state.user.token);

  useEffect(() => {
    if (props.viewOfflineRegister && fields.length === 3) {
      let arr = [...fields];
      arr.pop();
      setFields(arr);
    }

    let id = props.roomId;
    if (props.roomId !== null && id.roomId !== 0 && props.infoView) {
      // modo EDIT
      axios
        .get(`${URL.api}community/room/singleView/${id.roomId}`, {
          headers: { authorization: `Bearer ${token}` }
        })
        .then(resp => {
          if (
            props.infoView.room_id !== null
              ? props.roomId.roomId === props.infoView.room_id
              : false
          ) {
            let arrStudents = [];
            let users = props.infoView.users;
            users.forEach(item => {
              let obj = {
                id: item.id,
                nome: item.nome,
                status: item.status
              };
              arrStudents.push(obj);
            });
            setUsersData(arrStudents);
            props.getStudentList(arrStudents);
          } else {
            let arrStudents = [];
            let users = resp.data.data.room_user;
            users.forEach(item => {
              if (item.role_id === 7) {
                let obj = {
                  id: item.user_id,
                  nome: item.user_name,
                  status: "Presente"
                };
                arrStudents.push(obj);
              }
            });

            setUsersData(arrStudents);
            props.getStudentList(arrStudents);
          }
        });
    } else if (props.roomId !== null && id.roomId !== 0 && !props.infoView) {
      // modo CREATE
      axios
        .get(`${URL.api}community/room/singleView/${id.roomId}`, {
          headers: { authorization: `Bearer ${token}` }
        })
        .then(resp => {
          let arrStudents = [];
          let users = resp.data.data.room_user;
          users.forEach(item => {
            if (item.role_id === 7) {
              let obj = {
                id: item.user_id,
                nome: item.user_name,
                status: "Presente"
              };
              arrStudents.push(obj);
            }
          });
          setUsersData(arrStudents);
          props.getStudentList(arrStudents);
        });
    }
  }, [props.roomId]);

  const changePresence = studentName => {
    let newUsersData = [...usersData];

    newUsersData.forEach((elem, index) => {
      if (elem.nome === studentName) {
        if (elem.status === "Presente") {
          elem.status = "Ausente";
        } else {
          elem.status = "Presente";
        }
      }
    });
    setUsersData(newUsersData);
    props.getStudentList(newUsersData);
  };

  const getBadge = status => {
    switch (status) {
      case "Presente":
        return "success";
      case "Inactive":
        return "secondary";
      case "Pending":
        return "warning";
      case "Ausente":
        return "danger";
      default:
        return "primary";
    }
  };

  return (
    <>
      <CDataTable
        items={props.viewOfflineRegister ? props.infoView.users : usersData}
        fields={fields}
        // columnFilter
        // tableFilter
        footer
        // itemsPerPageSelect
        // itemsPerPage={5}
        hover
        // sorter
        // pagination
        scopedSlots={{
          status: item => (
            <td>
              <CBadge color={getBadge(item.status)}>{item.status}</CBadge>
            </td>
          ),
          show_details: !props.viewOfflineRegister
            ? (item, index) => (
                <td className="py-2">
                  <CButton
                    size="sm"
                    color="info"
                    onClick={() => changePresence(item.nome)}
                  >
                    Marcar{" "}
                    {item.status === "Presente" ? "Ausência" : "Presença"}
                  </CButton>
                </td>
              )
            : null
        }}
      />
    </>
  );
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudentPresenceTable);
